import { useFormContext } from 'react-hook-form';
import { StyledVariantTextAreaFormField } from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';
import { TextFormFieldProps } from 'modules/experiments/types';
import { TextAreaField } from 'lib/iterable-hook-form';
import { useSchemaValidationErrorTranslations } from 'utils/hooks/useTranslation';
import { ReadOnlyValue } from '../ReadOnlyValue';

export const TextAreaWithErrorContext = ({
  dataTestId,
  isFieldEditable,
  isFieldFocused = false,
  fieldLabel,
  fieldName,
  fieldValue,
  fieldTemplateErrors,
  helperText,
}: TextFormFieldProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const { zt } = useSchemaValidationErrorTranslations();

  const errorKey = errors[fieldName]?.message?.toString() ?? '';
  const errorText = zt(errorKey) || fieldTemplateErrors;
  const hasError = !!errors[fieldName] || !!fieldTemplateErrors?.length;

  return (
    <StyledVariantTextAreaFormField
      data-test={dataTestId}
      labelText={fieldLabel}
      hasError={hasError}
      errorText={errorText}
      helpText={isFieldEditable ? helperText : null}
      isHorizontalLayout
    >
      {isFieldEditable ? (
        <TextAreaField name={fieldName} autoFocus={isFieldFocused} />
      ) : (
        <ReadOnlyValue>{fieldValue}</ReadOnlyValue>
      )}
    </StyledVariantTextAreaFormField>
  );
};
